import { RepositoryFactory } from '@/api/RepositoryFactory'
const Auto = RepositoryFactory.get('auto')
const approvementsApi = RepositoryFactory.get('approvements')

import { APPROVEMENTS_AUTO } from './actions/approvements'
import {
  DELETE_AUTO,
  FETCH_AUTOS_STATS,
  SET_LOADING_STATS,
} from './actions/autos'
import { deleteError } from '@/datas/Messages'
import { mutateEntity } from '@/helpers/store'

const resultIsValid = res =>
  res && res.data && res.data.items && res.data.items.length

export default {
  namespaced: true,
  state: {
    items: [],
    pagination: {},
    loading: false,
    loadingStats: false,
    approvStatistics: {},
    autoTypes: [],
  },
  getters: {
    getAutos(state) {
      return state.items
    },
    getAutosPagination(state) {
      return state.pagination
    },
    getAutosById(state) {
      return id => state.items.find(item => Number(item.id) === Number(id))
    },
    getAutoLoading: state => state.loading,
    getAutoTypes: state => state.autoTypes,
  },
  actions: {
    fetchAutos({ commit }, payload) {
      commit('loadingStart')
      const page = payload && payload.page ? payload.page : false
      const status = payload && payload.status ? payload.status : false

      Auto.getList(page, status)
        .then(res => commit('updateAutos', res.data))
        .catch(() => commit('loadingStop'))
    },
    fetchAutosNew({ commit }, payload) {
      commit('loadingStart')
      const { page, org_id, search } = payload || {}

      Auto.getListMobile(page, org_id, search)
        .then(res => commit('updateAutos', res.data))
        .catch(() => commit('loadingStop'))
    },
    fetchFilterAutos({ commit }, search) {
      commit('loadingStart')
      Auto.searchCar(search)
        .then(res => {
          if (resultIsValid(res)) {
            commit('updateAutos', res.data)
          } else {
            Auto.searchCarByName(search)
              .then(res => {
                if (resultIsValid(res)) {
                  commit('updateAutos', res.data)
                } else {
                  Auto.searchCarByInn(search)
                    .then(res => commit('updateAutos', res.data))
                    .catch(() => commit('loadingStop'))
                }
              })
              .catch(() => commit('loadingStop'))
          }
        })
        .catch(() => commit('loadingStop'))
    },
    [DELETE_AUTO]: ({ commit }, id) => {
      Auto.deleteAuto(id)
        .then(() => commit(DELETE_AUTO, id))
        .catch(() => {
          throw new Error(deleteError)
        })
    },
    async fetchAutosStats({ commit }) {
      commit(SET_LOADING_STATS, true)
      try {
        const { data } = await approvementsApi.fetchApprovements('automobiles')

        commit(FETCH_AUTOS_STATS, data.by_meaning)
      } catch (error) {
        console.log(`error `, error)
      } finally {
        commit(SET_LOADING_STATS, false)
      }
    },
    fetchAutoTypes({ commit }) {
      commit('loadingStart')
      Auto.getAutoTypes(status)
        .then(res => commit('setTypes', res.data))
        .catch(() => commit('loadingStop'))
    },
  },
  mutations: {
    [APPROVEMENTS_AUTO]: (state, data) => {
      let newStateData = mutateEntity(state.items, data)

      if (newStateData instanceof Object) {
        state.items[newStateData.index] = Object.assign(
          {},
          newStateData.newState,
        )
      }
    },
    updateAutos(state, { items, _meta }) {
      state.items = items
      state.pagination = _meta
      state.loading = false
    },
    setTypes(state, items) {
      state.autoTypes = items
    },
    [DELETE_AUTO]: (state, id) => {
      state.items = state.items.filter(item => item.id !== id)
    },
    loadingStart(state) {
      state.loading = true
    },
    loadingStop(state) {
      state.loading = false
    },
    getAutosById(state) {
      return id => state.items.find(item => Number(item.id) === Number(id))
    },
    [SET_LOADING_STATS](state, payload) {
      state.loadingStats = Boolean(payload)
    },
    [FETCH_AUTOS_STATS](state, payload) {
      state.approvStatistics = payload
    },
  },
}
